import React from 'react';
import { Card } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import PaymentOrdersTable from '../../components/PaymentOrdersTable';

const PaymentOrders = () => {
  const { t } = useTranslation();

  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>{t('payment_orders.title')}</Card.Header>
          <PaymentOrdersTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default PaymentOrders;
